export default {
  deleteProduct(state, id) {
    const newCart = state.products.filter(product => product.id !== id);
    state.products = newCart;
  }
}